import UserService from "@/services/UserService";
import M from "materialize-css";
export default {
  name: "FirstLogon",
  data: () => ({
    buttonText: "შემოწმება",
    username: "",
    showOtpBox: false,
    otp: "",
    password: "",
    rePassword: "",
  }),
  components: {},
  mounted() {
    const User = JSON.parse(localStorage.getItem("User"));
    if (User.passwordMustChanged) {
      this.username = User.fullName;
      this.$nextTick(function () {
        M.updateTextFields();
      });
      UserService.CheckUser(this.username).then((res) => {
        this.showOtpBox = res.checkStatus;
        if (!res.checkStatus) {
          this.$message("მომხმარებელი ვერ მოიძებნა");
        } else {
          this.buttonText = "გაგრძელება";
        }
      });
    } else {
      this.$router.push("/contact");
    }
  },
  methods: {
    submitHandler() {
      if (this.rePassword == this.password) {
        UserService.ResetPassword(
          this.username,
          this.otp,
          this.rePassword
        ).then((res) => {
          if (res.resetStatusCode == 0) {
            this.$message(
              "პაროლი წარმატებით შეიცვალა, გთხოვთ გაიაროთ ავტორიზაცია"
            );
            const User = JSON.parse(localStorage.getItem("User"));
            User.passwordMustChanged = false;
            localStorage.setItem("User", JSON.stringify(User));
            this.$router.push("/contact");
          }
        });
      } else {
        this.$message("პაროლები არ ემთხვევა ერთმანეთს");
      }
    },
  },
};
